<div class="search-dropdown"
  [ngClass]="{'open':shown && list !== undefined && list?.length !== 0,'small':size=='small'}">
  <div class="search-dropdown__btn" >
    <div  style="display: flex;flex-direction: row;align-content: center;align-items: center;">
      <span (click)="show()">{{value | titlecase}} </span>
      <i class="fa fa-times primary" style=" cursor: pointer;display: flex;justify-content: flex-end;flex-direction: column;align-items: flex-end;width: 10%;"
       (click)="reset()" aria-hidden="true" *ngIf="value != 'All' && value != 'Please Select'"></i>
    </div>
  </div>


  <div class="search-dropdown__dropdown">
    <input class="search-dropdown__dropdown__search" type="text" placeholder="Search" [(ngModel)]="keyword"
      (keyup)="search(keyword)" #input />
    <div class="search-dropdown__dropdown__scroller">
      <div class="search-dropdown__dropdown__item" *ngFor="let item of list" (click)="select(item)">
        {{item[_label] | titlecase}}
      </div>
      <div class="search-dropdown__dropdown__msg" *ngIf="list?.length == 0">No Result Found</div>
    </div>
  </div>
  
</div>